import React from "react";
import ServicesList from "../components/ServicesList";
import BackButton from "../components/BackButton";
import { ReactComponent as ArrowIcon } from "../inlineSvgs/arrow-left.svg";

const SelectServicePage = ({ displayHead }) => {
  return (
    <div>
      {displayHead && (
        <div className="mobile-booking-head">
          <BackButton className="back-btn">
            <ArrowIcon />
          </BackButton>
          <div className="title">Select Service</div>
        </div>
      )}
      <ServicesList />
    </div>
  );
};

export default SelectServicePage;
